import { BackgroundOrbits } from "../components/BackgroundOrbits";
import { Faq } from "../components/Faq";
import { FeatureStrip } from "../components/FeatureStrip";
import { ConversionWorkspace } from "../features/conversion/ConversionWorkspace";

export function HomePage() {
  return (
    <main className="page-main">
      <BackgroundOrbits />
      <section className="hero-shell">
        <div className="hero-copy">
          <span className="eyebrow">PDF 工具</span>
          <h1>
            PDF 转 <span>Word</span>
          </h1>
          <p>将 PDF 转换为可编辑的 Word 文档</p>
        </div>
        <ConversionWorkspace />
        <FeatureStrip />
        <Faq />
      </section>
    </main>
  );
}
